function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
const calculateBalancedLayout = colorOptions => {
  const numOfOptions = colorOptions.length;
  const lines = Math.ceil(numOfOptions / 10);

  // Move the options from the last line (remaining options) to the previous lines
  const columnsPerLine = [];
  const base = Math.floor(numOfOptions / lines);
  let extras = numOfOptions % lines;
  let i = 0;
  while (i < lines) {
    columnsPerLine.push(base + (extras > 0 ? 1 : 0));
    extras -= 1;
    i += 1;
  }
  return {
    columnsPerLine,
    maxCols: Math.max(...columnsPerLine)
  };
};
const ColorSwatches = ({
  colorOptions,
  buttonProps
}) => {
  const {
    columnsPerLine,
    maxCols
  } = calculateBalancedLayout(colorOptions);
  const swatches = [];
  let colorIndex = 0;
  let lineIndex = 0;
  columnsPerLine.forEach(cols => {
    // Add colors of the line
    let i = 0;
    while (i < cols) {
      const color = colorOptions[colorIndex];
      colorIndex += 1;
      swatches.push(/*#__PURE__*/React.createElement(Button, _objectSpread({
        key: `color-${colorIndex}`
      }, buttonProps(color))));
      i += 1;
    }

    // Add invisible spacers to complete the line
    let j = i;
    while (j < maxCols) {
      swatches.push(/*#__PURE__*/React.createElement("div", {
        key: `spacer-${lineIndex}-${j}`,
        className: "color-swatch-spacer"
      }));
      j += 1;
    }
    lineIndex += 1;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "color-swatch-container",
    style: {
      gridTemplateColumns: `repeat(${maxCols}, 40px)`
    }
  }, swatches);
};
ColorSwatches.propTypes = {
  colorOptions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})])).isRequired,
  buttonProps: PropTypes.func.isRequired
};
export default ColorSwatches;